import { useState, useEffect, useRef } from "react";
import axios from "axios";

export default function SkinAnalysis() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [originalImage, setOriginalImage] = useState("");
  const [markedImage, setMarkedImage] = useState("");
  const [skinAnalysis, setSkinAnalysis] = useState("");
  const [fashionAdvice, setFashionAdvice] = useState([]);
  const [loading, setLoading] = useState(false);
  const [query, setQuery] = useState("");
  const chatRef = useRef(null);

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleUpload = async () => {
    if (!selectedFile) return;
    setLoading(true);
    const formData = new FormData();
    formData.append("file", selectedFile);

    try {
      const response = await axios.post("https://api.hauteuar.com/analyze", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      setOriginalImage(response.data.original_image);
      setMarkedImage(response.data.marked_image);
      setSkinAnalysis(response.data.skin_analysis);
    } catch (error) {
      alert("Error analyzing image");
    }
    setLoading(false);
  };

  const getAdvice = async () => {

    if (!skinAnalysis) return;
    setLoading(true);
    try {
      const response = await axios.post("https://api.hauteuar.com/fashion-advice", {
        skin_analysis: skinAnalysis,
        user_query: query,
      });
      setFashionAdvice([...fashionAdvice, { user: query, bot: response.data.advice }]);
      setQuery("");
    } catch (error) {
      alert("Error fetching fashion advice");
    }
    setLoading(false);
  };

  useEffect(() => {
    if (chatRef.current) {
      chatRef.current.scrollTop = chatRef.current.scrollHeight;
    }
  }, [fashionAdvice]);

  return (
    <div className="max-w-3xl mx-auto p-8 bg-white shadow-lg rounded-lg">
      <h1 className="text-2xl font-bold text-center mb-6 text-blue-600">Skin Tone Analysis</h1>
      <div className="flex flex-col items-center gap-6">
        <input type="file" accept="image/*" onChange={handleFileChange} className="border p-3 rounded-lg" />
        <button
          onClick={handleUpload}
          className="bg-blue-500 text-white py-3 px-6 rounded-lg hover:bg-blue-600 transition"
          disabled={loading}
        >
          {loading ? "Analyzing..." : "Upload & Analyze"}
        </button>
      </div>

      {originalImage && <img src={originalImage} alt="Uploaded" className="mt-6 rounded-lg shadow" />}
      {markedImage && <img src={markedImage} alt="Analyzed" className="mt-6 rounded-lg shadow" />}
      
      {skinAnalysis && (
        <div className="mt-6 p-5 bg-gray-100 rounded-lg text-lg">
          <h3 className="font-semibold text-xl">Skin Analysis Result</h3>
          <p className="mt-3">{skinAnalysis}</p>
        </div>
      )}

      <div className="mt-10 p-6 border rounded-lg bg-gray-50 shadow-md">
        <h2 className="text-lg font-semibold mb-4">Ask for Fashion Advice based on skintone analysis</h2><h4>powered by AI</h4>
        <div className="h-72 overflow-y-auto border p-4 rounded bg-white" ref={chatRef}>
          {fashionAdvice.map((msg, index) => (
            <div key={index} className="mb-6">
              <p className="bg-blue-100 p-3 rounded-lg self-end text-lg">You: {msg.user}</p>
              <p className="bg-green-100 p-3 rounded-lg mt-3 text-lg">Fashion AI: {msg.bot}</p>
            </div>
          ))}
        </div>
        <div className="mt-6 flex gap-4">
          <input
            type="text"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            placeholder="Ask for fashion advice..."
            className="flex-grow h-16 border p-3 rounded-lg text-lg"
          />
          <button
            onClick={getAdvice}
            color="blue"
            className="bg-teal-500 text-white py-3 px-6 rounded-lg hover:bg-teal-600 transition"
            disabled={loading}
          >
            {loading ? "Fetching..." : "Get Advice"}
          </button>
        </div>
      </div>
    </div>
  );
}
